import api from './api';

export default (url: string) => api.get(url).then((res) => res.data);
